// import React from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
// } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles((theme) => ({
//   dialog: {
//     '& .MuiDialog-paper': {
//       borderRadius: 8,
//       padding: theme.spacing(2),
//       minWidth: 400,
//     },
//   },
//   title: {
//     textAlign: 'center',
//     fontWeight: 600,
//     fontSize: '18px',
//     color: '#333',
//     paddingBottom: theme.spacing(2),
//   },
//   content: {
//     textAlign: 'center',
//     paddingBottom: theme.spacing(3),
//   },
//   message: {
//     fontSize: '16px',
//     color: '#666',
//     marginBottom: theme.spacing(3),
//   },
//   buttonContainer: {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: theme.spacing(2),
//   },
//   passwordButton: {
//     backgroundColor: '#007bff',
//     color: 'white',
//     padding: theme.spacing(1, 3),
//     textTransform: 'none',
//     fontWeight: 500,
//     '&:hover': {
//       backgroundColor: '#0056b3',
//     },
//   },
//   authButton: {
//     backgroundColor: '#28a745',
//     color: 'white',
//     padding: theme.spacing(1, 3),
//     textTransform: 'none',
//     fontWeight: 500,
//     '&:hover': {
//       backgroundColor: '#1e7e34',
//     },
//   },
//   cancelButton: {
//     color: '#6c757d',
//     textTransform: 'none',
//   },
// }));

// interface KeyGenerationModalProps {
//   open: boolean;
//   onClose: () => void;
//   onPasswordSelect: () => void;
//   onAuthCodeSelect: () => void;
// }

// const KeyGenerationModal: React.FC<KeyGenerationModalProps> = ({
//   open,
//   onClose,
//   onPasswordSelect,
//   onAuthCodeSelect,
// }) => {
//   const classes = useStyles();

//   const handlePasswordSelect = () => {
//     onPasswordSelect();
//     onClose();
//   };

//   const handleAuthCodeSelect = () => {
//     onAuthCodeSelect();
//     onClose();
//   };

//   return (
//     <Dialog open={open} onClose={onClose} className={classes.dialog}>
//       <DialogTitle className={classes.title}>
//         Generate API Key
//       </DialogTitle>
//       <DialogContent className={classes.content}>
//         <Typography className={classes.message}>
//           Do you want to generate code based on?
//         </Typography>
//         <Box className={classes.buttonContainer}>
//           <Button
//             className={classes.passwordButton}
//             onClick={handlePasswordSelect}
//             variant="contained"
//           >
//             Password
//           </Button>
//           <Button
//             className={classes.authButton}
//             onClick={handleAuthCodeSelect}
//             variant="contained"
//           >
//             Authorization Code
//           </Button>
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} className={classes.cancelButton}>
//           Cancel
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default KeyGenerationModal;

import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Typography, Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 8,
      padding: theme.spacing(2),
      minWidth: 400,
      position: 'relative',
    },
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '18px',
    color: '#333',
    paddingBottom: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#999',
  },
  content: {
    textAlign: 'center',
    paddingBottom: theme.spacing(3),
  },
  message: {
    fontSize: '16px',
    color: '#666',
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  passwordButton: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: theme.spacing(1, 3),
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#0056b3',
    },
  },
  authButton: {
    backgroundColor: '#28a745',
    color: 'white',
    padding: theme.spacing(1, 3),
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#1e7e34',
    },
  },
}));

interface KeyGenerationModalProps {
  open: boolean;
  onClose: () => void;
  onPasswordSelect: () => void;
  onAuthCodeSelect: () => void;
}

const KeyGenerationModal: React.FC<KeyGenerationModalProps> = ({
  open,
  onClose,
  onPasswordSelect,
  onAuthCodeSelect,
}) => {
  const classes = useStyles();

  const handlePasswordSelect = () => {
    onPasswordSelect();
    onClose();
  };

  const handleAuthCodeSelect = () => {
    onAuthCodeSelect();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <DialogTitle disableTypography className={classes.title}>
        Generate API Key
        <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Typography className={classes.message}>Choose a method to generate your API key:</Typography>

        <Box className={classes.buttonContainer}>
          <Button className={classes.passwordButton} onClick={handlePasswordSelect} variant='contained'>
            Use Password
          </Button>

          <Button className={classes.authButton} onClick={handleAuthCodeSelect} variant='contained'>
            Use Authorization Code
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default KeyGenerationModal;
